import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const listarTitulosNotificacoes = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/sino`, 'GET');
}

export const listarNotificacoes = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/enviadas`, 'GET');
}

export const criarNotificacao = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao`, 'POST', data);
}

export const marcarComoLida = async (id) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/marcar-como-vista/` + id, 'POST');
}
export const deletarNotificacoes = async (id) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/remover-notificacao/`+id, 'POST');
}
export const detalheNotificacoes = async (notificacaoId) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/${notificacaoId}`, 'GET');
}

export const alterarNoticacao = async (notificacaoId, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}notificacao/${notificacaoId}`, 'PUT', data);
}
